<template>
  <div>
    <p v-if="displayType === 'long'">
      Unclassified holdings include private asset classes and other alternative investments.
      Geographic classification is based on the country of domicile of the company.
      Asset allocation data from funds uses holdings as of data of most recent NPORT SEC filing.
      Allocation percentages for funds are calculated using the fund's net assets (total assets minus liabilities).
    </p>

    <p v-else>
      Unclassified holdings include private asset classes and other alternative investments.
      Geographic classification is based on the country of domicile of the company.
      Asset allocation data from funds uses holdings as of data of most recent NPORT SEC filing.
      Allocation percentages for funds are calculated using the fund's net assets (total assets minus liabilities).
    </p>
  </div>
</template>


<script>
export default {
  name: 'AssetLocationMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
};
</script>
